import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ComponentActionForm from '../../../components/forms/ComponentActionForm';
import { useComponentActionApi } from '../../../hooks/useComponentActionApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ComponentActionDTO } from '../../../services/apiClient';

const ComponentActionEdit: React.FC = () => {
  const { getById, edit, isLoading } = useComponentActionApi();
  const [entityData, setEntityData] = useState<ComponentActionDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Component Actions', href: '/admin/componentactions' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching ComponentAction data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/componentactions');
    } catch (error) {
      console.error('Error updating ComponentAction:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/componentactions"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ComponentAction.Edit"
    >
        {entityData ? (
          <ComponentActionForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/componentactions')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ComponentActionEdit;
